module.exports = __webpack_public_path__ + "img/shadow.c9e873a6.png";